import AccountMarketingMaterialCustomDesignTemplate from './AccountMarketingMaterialCustomDesignTemplate';

export default AccountMarketingMaterialCustomDesignTemplate;
